import './helpers/shims'; // Import shims first!
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';

import { Provider } from 'react-redux';
import { configureStore } from './redux/store';

import TagManager from 'react-gtm-module';
import ScriptTag from './components/ScriptTag';

const tagManagerArgs = {
    gtmId: import.meta.env.VITE_GOOGLE_TAG_MANAGER_ID
}

TagManager.initialize(tagManagerArgs);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.Fragment>
        <ScriptTag type="text/javascript" dangerouslySetInnerHTML={{__html:`
                    (function(w){w.fpr=w.fpr||function(){w.fpr.q = w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);
                    fpr("init", {cid:"${import.meta.env.VITE_FIRST_PROMOTER_ACCOUNT_ID}"});
                    fpr("click");
                `}} async />
        <ScriptTag type="text/javascript" src="https://cdn.firstpromoter.com/fpr.js" async />
        <Provider store={configureStore()}>
            <App />
        </Provider>
    </React.Fragment>,
);
